import { render, staticRenderFns } from "./scoreInquiry.vue?vue&type=template&id=1c9dc671&scoped=true"
import script from "./scoreInquiry.vue?vue&type=script&lang=js"
export * from "./scoreInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9dc671",
  null
  
)

export default component.exports